import { useEffect } from 'react';
import {
    Calendar, Smartphone, CreditCard, Users2, Cpu, BarChart,
    ShieldCheck, Target, ArrowRight, Zap, Rocket, CheckCircle2,
    QrCode, ShoppingCart, Brain, Megaphone, Globe, Palette
} from 'lucide-react';
import { Link } from 'react-router-dom';

const DocsRoadmap = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const roadmapData = [
        {
            quarter: 'Q1 2026',
            title: 'Kurulus & Temel Altyapi',
            desc: 'fraxlabs\'in kurulmasi, ugra platformunun temel mimarisinin olusturulmasi ve ilk modullerin gelistirilmesi.',
            items: [
                { icon: Zap, label: 'Supabase & Vercel Altyapisi', text: 'Multi-tenant PostgreSQL veritabani, Row Level Security, Vercel serverless deployment.', color: '#0ea5e9' },
                { icon: QrCode, label: 'QR Menu Modulu', text: 'Kategoriler, urunler, gorseller ile dijital menu yonetimi. Anlik guncelleme.', color: '#10b981' },
                { icon: Smartphone, label: 'Musteri Portali', text: 'QR kod ile check-in, dijital menu goruntuleme, sadakat puani takibi.', color: '#f59e0b' },
            ],
            status: 'completed'
        },
        {
            quarter: 'Q2 2026',
            title: 'CRM & Operasyon Modulleri',
            desc: 'Musteri iliskileri yonetimi, siparis takibi ve isletme operasyonlarini dijitallestiren modullerin devreye alinmasi.',
            items: [
                { icon: Users2, label: 'Musteri CRM', text: 'Sinir-siz musteri kaydi, sadakat seviyeleri, ziyaret frekansi analizi, segmentasyon.', color: '#8b5cf6' },
                { icon: ShoppingCart, label: 'Siparis Yonetimi', text: 'Portaldan gelen siparislerin gercek zamanli takibi, durum guncelleme.', color: '#ec4899' },
                { icon: Megaphone, label: 'Kampanya & Kuponlar', text: 'Hedefli kampanyalar, odul sistemi, kupon olusturma ve kullandirma.', color: '#f59e0b' },
            ],
            status: 'current'
        },
        {
            quarter: 'Q3 2026',
            title: 'Pro & Premium Planlari',
            desc: '3 kademeli plan sistemi, odeme entegrasyonlari ve yapay zeka destekli danismanlik ozelliklerinin devreye alinmasi.',
            items: [
                { icon: CreditCard, label: 'iyzico Odeme Entegrasyonu', text: 'Guvenli online odeme, taksit destegi, otomatik plan yukseltme.', color: '#6366f1' },
                { icon: Brain, label: 'AI Danismanlik (Gemini)', text: 'Menu optimizasyonu, kampanya onerisi, stok analizi. Premium plana ozel.', color: '#3b82f6' },
                { icon: BarChart, label: 'Analitik & Raporlar', text: 'Gelir analizi, musteri dagilimi, kampanya performansi, trend grafikleri.', color: '#14b8a6' },
            ],
            status: 'future'
        },
        {
            quarter: 'Q4 2026',
            title: 'Ekosistem Genislemesi',
            desc: 'Yeni entegrasyonlar, gelismis ozellikler ve Turkiye genelinde yayginlasma hedefi.',
            items: [
                { icon: Globe, label: 'Yeni Odeme Entegrasyonlari', text: 'Odeal, PayTR ve yerel dijital cuzdan entegrasyonlari.', color: '#f97316' },
                { icon: ShieldCheck, label: 'KVKK & Mevzuat', text: 'Tam KVKK uyumu, aydinlatma metni entegrasyonu, veri isleme sozlesmesi.', color: '#22c55e' },
                { icon: Palette, label: 'Beyaz Etiket & API', text: 'Isletmelerin kendi markalariyla kullanabilecegi ozelestirme secenekleri.', color: '#a855f7' },
            ],
            status: 'future'
        }
    ];

    return (
        <div style={{ animation: 'fadeIn 0.3s ease-out' }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 900, marginBottom: '1rem', letterSpacing: '-0.02em', borderBottom: '1px solid var(--border)', paddingBottom: '1.5rem' }}>
                Roadmap
            </h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem', marginBottom: '3rem', lineHeight: 1.6 }}>
                ugra platformunun 2026 yılı hedefleri ve geliştirme planları. Yeni özelliklerin ve güncellemelerin ne zaman geleceğini buradan takip edebilirsiniz.
            </p>

            <style>{`
                .rm-card { background: var(--bg-card); border: 1px solid var(--border); border-radius: 16px; padding: 1.5rem; display: flex; gap: 1rem; align-items: flex-start; transition: all 0.3s; }
                .rm-card:hover { border-color: var(--primary); transform: translateY(-2px); box-shadow: 0 4px 20px rgba(0,0,0,0.05); }
                .rm-phase { position: relative; padding-left: 2.5rem; }
                .rm-phase::before { content: ''; position: absolute; left: 5px; top: 0; bottom: -3rem; width: 2px; background: var(--border); }
                .rm-phase:last-child::before { display: none; }
                .rm-dot { position: absolute; left: 0; top: 6px; width: 12px; height: 12px; border-radius: 50%; background: var(--border); }
                .rm-phase.completed .rm-dot { background: #10b981; }
                .rm-phase.current .rm-dot { background: var(--primary); box-shadow: 0 0 0 4px rgba(var(--primary-rgb), 0.2); }
                @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '3rem' }}>
                {roadmapData.map((phase, idx) => (
                    <div key={idx} className={`rm-phase ${phase.status}`}>
                        <div className="rm-dot" />
                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: phase.status === 'completed' ? 'rgba(16, 185, 129, 0.1)' : phase.status === 'current' ? 'rgba(var(--primary-rgb), 0.1)' : 'var(--bg-main)', color: phase.status === 'completed' ? '#10b981' : phase.status === 'current' ? 'var(--primary)' : 'var(--text-muted)', padding: '6px 12px', borderRadius: 8, fontSize: '0.75rem', fontWeight: 800, marginBottom: '0.75rem', border: phase.status === 'future' ? '1px solid var(--border)' : 'none' }}>
                            <Calendar size={14} /> {phase.quarter}
                            {phase.status === 'completed' && <CheckCircle2 size={14} />}
                            {phase.status === 'current' && <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--primary)', animation: 'pulse 2s infinite' }} />}
                        </div>
                        <h3 style={{ fontSize: '1.4rem', fontWeight: 800, marginBottom: '0.5rem' }}>{phase.title}</h3>
                        <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', lineHeight: 1.6, marginBottom: '1.5rem' }}>{phase.desc}</p>
                        
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem' }}>
                            {phase.items.map((item, i) => (
                                <div key={i} className="rm-card">
                                    <div style={{ width: 40, height: 40, borderRadius: 10, background: `${item.color}15`, color: item.color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <item.icon size={20} />
                                    </div>
                                    <div>
                                        <h4 style={{ fontWeight: 700, fontSize: '0.95rem', marginBottom: '0.25rem' }}>{item.label}</h4>
                                        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.5 }}>{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ marginTop: '4rem', padding: '2rem', background: 'rgba(var(--primary-rgb), 0.03)', borderRadius: '16px', border: '1px solid rgba(var(--primary-rgb), 0.1)', display: 'flex', alignItems: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: '250px' }}>
                    <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '1.25rem', fontWeight: 800, marginBottom: '0.5rem' }}>
                        <Rocket size={20} style={{ color: 'var(--primary)' }} /> 2027 Vizyonu
                    </h3>
                    <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', lineHeight: 1.6 }}>
                        Beyaz etiket secenekleri, acik API, yeni sektorlere genisleme ve uluslararasi pazarlara acilim. Türkiye pazarından sonra MENA bölgesi lansmanı.
                    </p>
                </div>
                <Link to="/whitepaper" style={{ background: 'var(--primary)', color: 'white', padding: '0.75rem 1.5rem', borderRadius: '10px', textDecoration: 'none', fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                    Whitepaper Oku <ArrowRight size={18} />
                </Link>
            </div>
        </div>
    );
};

export default DocsRoadmap;
